<template>
  <div class="img-wrapper">
    <img :src="image" class="img"/>
  </div>
</template>

<script>
import dfltIMG from "@/assets/img/servicios/default.png";
export default {
  props: {
    imageUrl: String
  },
  computed: {
    image(){
      return (this.imageUrl === "" || !this.imageUrl) ? dfltIMG: `local-resource://${this.imageUrl}`;
    }, 
  }
}
</script>

<style scoped>
  .img-wrapper{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
  }

  .img{
    max-height: 35px;
    border-radius: 4px;
  }
</style>